export const NOTIFICATION_TYPES = [
  {
    id: '1',
    value: 1,
    code: 'general',
    label: 'General',
    count: 0,
    isShow: true,
  },
  {
    id: '2',
    value: 3,
    code: 'inbox',
    label: 'Inbox',
    count: 0,
    isShow: true,
  },
  {
    id: '3',
    value: 2,
    code: 'approval',
    label: 'Approval',
    count: 0,
    isShow: true,
  },
]

export const NOTIFICATION_CATEGORIES = [
  {
    id: '1',
    value: 1,
    code: 'reminder',
    label: 'Reminder',
    typeId: 1,
    isShow: true,
  },
  {
    id: '2',
    value: 2,
    code: 'mention',
    label: 'Mention',
    typeId: 1,
    isShow: true,
  },
  {
    id: '3',
    value: 3,
    code: 'assignment',
    label: 'Assignment',
    typeId: 1,
    isShow: true,
  },
  {
    id: '4',
    value: 4,
    code: 'update',
    label: 'Update',
    typeId: 1,
    isShow: true,
  },
  {
    id: '5',
    value: 5,
    code: 'download_upload',
    label: 'Download and Upload',
    typeId: 1,
    isShow: true,
  },
  {
    id: '6',
    value: 6,
    code: 'upload',
    label: 'Upload',
    typeId: 1,
    isShow: false,
  },
  {
    id: '7',
    value: 7,
    code: 'others',
    label: 'Others',
    typeId: 1,
    isShow: false,
  },
  {
    id: '8',
    value: 8,
    code: 'deals',
    label: 'Deals',
    typeId: 2,
    isShow: true,
  },
  {
    id: '9',
    value: 9,
    code: 'expenses',
    label: 'Expenses',
    typeId: 2,
    isShow: true,
  },
  {
    id: '10',
    value: 10,
    code: 'incoming_chat',
    label: 'Incoming chat',
    typeId: 3,
    isShow: false,
  },
  {
    id: '11',
    value: 11,
    code: 'chat_assignment',
    label: 'Chat Assignments',
    typeId: 3,
    isShow: true,
  },
  {
    id: '12',
    value: 12,
    code: 'resolved_chat',
    label: 'Resolved chat',
    typeId: 3,
    isShow: true,
  },
  {
    id: '13',
    value: 13,
    code: 'blocked_contact',
    label: 'Blocked contact',
    typeId: 3,
    isShow: true,
  },
]
